import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";

const Tooltip = ({ text, children }) => {
  const [hover, setHover] = useState(false);

  return (
    <div
      className="relative w-fit"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      {children}

      <AnimatePresence>
        {hover && (
          <motion.div
            initial={{ opacity: 0, y: 8, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, y: 8, scale: 0.9 }}
            transition={{ duration: 0.2 }}
            className="absolute -top-10 left-1/2 -translate-x-1/2 
                       bg-[#1C1410] text-[#EDE0D0] text-xs px-3 py-1.5 
                       rounded-lg border border-[#3C2B22] z-10 shadow-lg whitespace-nowrap"
          >
            {text}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Tooltip;